<template>
  <div>
    <div class="table-box" style="paddingTop:10px">
      <el-button
        @click="back"
        type="text"
        style="display:flex"
        icon="el-icon-arrow-left"
      >
        返回
      </el-button>
      <!--查询-->
      <searchbar
        :searchEvent="searchEvent.bind(this)"
        :parent="this"
        :config="{ type: 'month' }"
      />
      <!--列表-->
      <div>
        <el-table
          style="width: 100%"
          ref="recordList"
          v-loading="loading"
          row-key="id"
          :data="tableData"
          :stripe="false"
          :highlight-current-row="false"
          header-row-class-name="noBorder"
        >
          <!-- <el-table-column
            type="selection"
            width="55"
            row-key="id"
            :reserve-selection="true"
          ></el-table-column> -->
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="userName"
            label="项目参与人"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            v-if="projectStructureType === 2"
            align="center"
            prop="userEnterpriseName"
            label="个体"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="userPhone"
            label="手机号"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="uvCount"
            label="点击数（UV）"
          ></el-table-column>
          <!-- <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="taskMonth"
            label="任务月度"
          ></el-table-column> -->
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="check(scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationData.pageNum"
          :total="totalElements"
          :page-size="paginationData.pageSize"
          layout="total, prev, pager, next, jumper"
          style="padding:15px"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import datePicker from "@/Mixin/datePicker";
import { project, receive, channel } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import searchbar from '@/components/Survey/searchbar';
import { setStorage, getStorage } from '@/tools/storage';

export default {
  mixins: [pageInation, makeSure, taskRecordHandles],
  data() {
    return {
      getList: channel.selectMonthTaskPerson, // 获取列表的AJAX
      projectStructureType: getStorage('homeProject').projectStructureType || 1,
      searchQuery: {
        projectId: this.$route.query.projectId,
        statementId: this.$route.query.statementId,
        month: '',
        ...getStorage('recordsearchQuery')
      }
    };
  },
  components: {
    searchbar
  },
  computed: {},
  methods: {
    back() {
      localStorage.removeItem('recordsearchQuery');
      this.$router.back();
    },
    check(row) {
      //去详情
      setStorage('recordsearchQuery', this.searchQuery);
      this.$router.push({
        name: 'spreadRecordDetail',
        query: {
          ...this.$route.query,
          userId: row.userId,
          month: this.searchQuery.month
        }
      });
    }
  },
  mounted() {},
  async created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
.table-dialog {
  .el-carousel__item {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      /*max-height: 600px;*/
      height: inherit;
    }
  }
}

.table-pic {
  object-fit: contain !important;
}

.show-modal-ca {
  /*width: 100%!important;*/
  height: 100% !important;
  object-fit: contain !important;
}
</style>
